import { defineComponent, computed } from 'vue';

var script = defineComponent({
    name: 'ColorCircle',
    props: {
        color: {
            type: String,
            required: true,
        },
        size: {
            type: Number,
            default: 14,
        },
    },
    setup(props) {
        const hexColor = computed(() => {
            switch (props.color) {
                case 'green':
                    return '#12B76A';
                case 'orange':
                    return '#ff9400';
                case 'red':
                    return '#F04438';
                case 'teal':
                    return '#00d3ff';
                case 'yellow':
                    return '#ffc857';
                case 'blue':
                    return '#166FCF';
                case 'light-blue':
                    return '#00D3FF';
                case 'dark-grey':
                    return '#081D34';
                default:
                    return `#${props.color}`;
            }
        });
        const style = computed(() => ({
            height: `${props.size}px`,
            width: `${props.size}px`,
            minWidth: `${props.size}px`,
            maxWidth: `${props.size}px`,
            borderRadius: '50%',
            backgroundColor: hexColor.value,
        }));
        return { style };
    },
});

export { script as default };
